// extracted by mini-css-extract-plugin
export var bottom = "index-module--bottom--bdb82";
export var item = "index-module--item--5d2fe";
export var socials = "index-module--socials--56e5a";